module.exports = __webpack_public_path__ + "static/Trans-2-Clean-c819c93a4870a4cc77be02ed9aca2576.svg";